/**
 * React component for displaying information and a video about Matic, the first truly smart robot.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.data - Data containing information for the component.
 * @returns {JSX.Element} React component.
 */

import React from "react";
import LazyVideoNew from "../LazyVideo/LazyVideoNew";

function MaticSeesMess({ data }) {
  return (
    <>
      <div className="w-full relative px-[80px] hidden lg:block mt-[80px]">
        <div className="aspect-w-1280 aspect-h-720">
          <div className="w-full z-1 lg:pt-[50px] xl:pt-[80px] grid grid-cols-12 lg:px-[60px] xl:px-[80px]">
            <div
              className={`d1 lg:col-span-12 xl:col-span-9 bigger:col-span-6 col-span-4 lg:text-[100px] xl:text-[120px]`}
            >
              {data?.meetTheFirstTrulySmartRobotTitle}
              <h6 className="lg:mt-[16px]">
                {data?.meetTheFirstTrulySmartRobotDescription}
              </h6>
            </div>
          </div>
          <LazyVideoNew
            videoImagePath={data.meetTheFirstTrulySmartRobotVideoContainer}
            isMobile={false}
            customClasses={`h-full w-full object-cover object-center rounded-[16px]`}
          />
        </div>
      </div>

      <div className="w-full relative block lg:hidden mt-[40px] px-[24px]">
        <div className="aspect-w-327 aspect-h-573 md:aspect-h-397">
          <div className="w-full z-1 pt-[32px] px-[32px]">
            <div className={`d1`}>
              {data?.meetTheFirstTrulySmartRobotTitle}
              <h6 className="mt-[16px]">
                {data?.meetTheFirstTrulySmartRobotDescription}
              </h6>
            </div>
          </div>
          <LazyVideoNew
            videoImagePath={data.meetTheFirstTrulySmartRobotVideoContainer}
            isMobile={true}
            customClasses={`h-full w-full object-cover object-bottom rounded-8`}
          />
        </div>
      </div>
    </>
  );
}

export default MaticSeesMess;
